import { TForecast, TWeatherForecast } from "./types"

export const getDimension = (units: string): string => {
    if (units === '')
        return '°C'
    if (units === 'metric')
        return '°C'
    if (units === 'standard')
        return 'K'
    if (units === 'imperial')
        return '°F'

    return '°C'

}

export const isWrongConfig = (app: TWeatherForecast) => {
    return !app.latitude || !app.longitude;
}

export const getForecast = (app:TWeatherForecast) : TForecast | undefined => {
    return app.forecast && app.forecast !== "" ? JSON.parse(app.forecast) : undefined;
}